import styled from 'styled-components'

const PageHeaderNavigationLeft = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
`

export default PageHeaderNavigationLeft